/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line  


  class BundleCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.initialised){
        return;
      }

      this.bindEvents();
      this.initialised = true;
    }

    bindEvents() {
      this.atcBtns = this.querySelectorAll('[data-bundle-atc-btn]')
      
      // update progress bar
      this.setImages();
      this._checkCart();

      this.atcBtns.forEach((btn) => {
        if (!btn.classList.contains('active')) {
          btn.addEventListener('click', () => this.toggleForm(btn.parentElement));
        }
      });
    }

    toggleForm(bundleATC) {
      if (!bundleATC.classList.contains('disabled')) {
        const activeEl = bundleATC.querySelector('bundle-atc.active');

        if (activeEl) {
          activeEl.classList.remove('active');
        }
        bundleATC.classList.add('active');

        // If first time adding to cart, automatically add one to cart
        this._updateQuantity(bundleATC);
        this._onAdd(bundleATC);
      };
    }
    
    async _checkCart() {
      let cartItemMatchQ = 1;
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      cartContent.items.forEach((item) => {
        const currAdded = this.querySelector(`[data-bundle-atc][data-variant-id="${item.id}"]`);
        if (currAdded) {
          cartItemMatchQ += item.quantity;
          currAdded.classList.add('active');
          currAdded.querySelector('.quantity-selector input[name="count"]').value = parseInt(item.quantity);

          this._updateQuantity(currAdded)
        }
      });
    }

    async _updateQuantity(currAdded) {
      const decreaseBtn = currAdded.querySelector('.quantity-selector button[aria-label="Decrease quantity"');
      const increaseBtn = currAdded.querySelector('.quantity-selector button[aria-label="Increase quantity"');

      // If click increase, it should add one product at a time.
      increaseBtn.addEventListener('click', () => {
        this._onAdd(currAdded);
      });

      // If click decrease, it should remove one product at a time.
      decreaseBtn.addEventListener('click', () => {
        this._onRemove(currAdded);
      });
    }
    
    async _onRemove(bundleATC) {
      let quantity = 0;
      this.lineKey = null;
      this.bundleATC = bundleATC;
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      const variantID = this.bundleATC.getAttribute('data-variant-id');

      for (let i = 0; i < cartContent.items.length; i++) {
        const item = cartContent.items[i];
        if (item.id === parseInt(variantID)) {
          this.lineKey = item.key;
          quantity = parseInt(item.quantity) - 1;

          const cartItem = document.querySelector(`.cart__item quantity-counter [data-id="${this.lineKey}"][name="updates[]"]`)
          cartItem.value = quantity;
          cartItem.dispatchEvent(
            new CustomEvent('theme:cart:update', {
              bubbles: true,
              item,
              detail: {
                id: this.lineKey,
                quantity: quantity,
              },
            })
          );

          const messageContainer = this.bundleATC.parentElement.querySelector('.cart-messages');
          messageContainer.innerHTML = `<p class="success">${quantity} in cart</p>`;
          setTimeout(() => {
            messageContainer.innerHTML = '';
          }, 3000);
        }
        break;
      };
    }

    async _onAdd(bundleATC) {
      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: {
            button: bundleATC,
          },
          bubbles: false,
        })
      );
    }
   
    async _updateProgress(bundleATC, item) {
      const bundleCollections = window.theme.settings.bundleCollections;
      const collectionList = bundleCollections !== null ? bundleCollections.split(',') : [];
      let eligibleProducts = JSON.parse(localStorage.getItem('bundleProducts')) ? JSON.parse(localStorage.getItem('bundleProducts')) : {tier: 0, products:[],};
      this.bundleBar = this.querySelector('.collection-bundle__progress-bar');

      // on add to cart
      if (bundleCollections !== null && bundleATC) {
        // check if eligible for bundle then update local storage and progress bar
        const list = bundleATC.querySelector('data-bundle-atc-btn').getAttribute('data-collection-list');
        this.list = list?.split(',');
        const eligible = this.list.filter((i) => collectionList.includes(i));

        if (eligible.length > 0 && eligible) {
          const productInfo = {
            key: item.key,
            handle: item.handle,
            id: item.id,
            title: item.title,
            price: item.original_price,
            image: item.image
          }
          eligibleProducts.products.push(productInfo);

          const firstEmptyBox = this.bundleBar.querySelectorAll('.progress-bar__box[data-activate="false"]')[0];
          if (firstEmptyBox) {
            firstEmptyBox.setAttribute('data-activate', true);
            firstEmptyBox.querySelector('p').innerHTML = `
              <img src="${item.image}" alt="${item.title}" width="100" height="100%" loading="lazy" />
            `;
          };
          // set tier
          const tierNumber = parseInt(window.theme.settings.bundleTotalTier);
          if ((eligibleProducts.products.length <= 3 && tierNumber > 1) || tierNumber === 1) {
            eligibleProducts.tier = 1;
          } else if (eligibleProducts.products.length > 3 && ((eligibleProducts.products.length <= 5 && tierNumber > 2) || tierNumber === 2)) {
            eligibleProducts.tier = 2;
          } else if (eligibleProducts.products.length > 5 && ((eligibleProducts.products.length <= 7 && tierNumber > 3) || tierNumber === 3)) {
            eligibleProducts.tier = 3;
          } else if (eligibleProducts.products.length > 7) {
            eligibleProducts.tier = 4;
          } else if (eligibleProducts.products.length === 0) {
            eligibleProducts.tier = 0;
          }
          
          localStorage.setItem('bundleProducts', JSON.stringify(eligibleProducts));

          this.setPrice(eligibleProducts);
          this.updateMessaging(eligibleProducts);
          this.updateCartProgressBar();
        }
      }
    }

    setImages() {
      this.bundleBar = this.querySelector('.collection-bundle__progress-bar');
      const bundle = JSON.parse(localStorage.getItem('bundleProducts'));

      if (bundle?.products) {
        const count = bundle.products.length;
        const boxes = this.bundleBar.querySelectorAll('.progress-bar__box');

        for (let i = 0; i < boxes.length; i++) {
          const boxCount = boxes[i].getAttribute('data-count');

          if (boxCount <= count) {
            boxes[i].setAttribute('data-activate', true);
            boxes[i].querySelector('p').innerHTML = `
              <img src="${bundle.products[i].image}" alt="${bundle.products[i].title}" width="100" height="100%" loading="lazy" />
            `;
          } else {
            // On load if does not apply set to deactivate
            boxes[i].setAttribute('data-activate', false);
            if (!boxes[i].classList.contains('discount-box')) {
              boxes[i].querySelector('p').innerText = boxCount;
            } else {
              boxes[i].querySelector('p').innerHTML = '';
            }
          }
        }
        this.setPrice(bundle);
        this.updateMessaging(bundle);
      }
      this.updateCartProgressBar();
    }

    setPrice(bundleObj) {
      const priceEl = this.querySelector('.collection-bundle__progress-bar .price');
      const discounts = window.theme.settings.bundleDiscountsPercentage.split(',');
      let total = 0;
      let totalPrice = 0;

      if (discounts !== null) {
        bundleObj.products.forEach((product) => {
          total += product.price
        });

        if (bundleObj.products.length >= 3) {
          const idx = bundleObj.products.length >= 9 ? 3 : bundleObj.products.length >= 7 ? 2 : bundleObj.products.length >= 5 ? 1 : 0;
          totalPrice = (total * (100 - discounts[idx])) / 100;
        } else {
          totalPrice = total;
        }
      }

      const price = Number.parseFloat(totalPrice / 100).toFixed(2);
      priceEl.innerHTML = `$${price}`;
    }

    updateMessaging(bundleObj) {
      const productCount = bundleObj.products.length;
      const messageEl = this.querySelector('.progress-bar__messaging .messaging');
      
      if (productCount !== 0) {
        const tierNumber = parseInt(window.theme.settings.bundleTotalTier);
        const boxes = this.querySelectorAll(`.progress-bar__box`).length;
        let discountAmount = bundleObj.tier !== 0 ? this.querySelector(`.progress-bar__box.discount-box .discount-label[data-tier="${bundleObj.tier}"]`)?.innerText : 0;     
        let quantityTo = 0;

        if (bundleObj.tier === 1) {
          quantityTo = productCount < 3 ? 3 - productCount : 2;
          discountAmount = productCount == 3 ? this.querySelector(`.progress-bar__box.discount-box .discount-label[data-tier="2"]`)?.innerText : discountAmount;
        } else if (bundleObj.tier === 2) {
          quantityTo = productCount < 5 ? 5 - productCount : 2;
          discountAmount = productCount == 5 ? this.querySelector(`.progress-bar__box.discount-box .discount-label[data-tier="3"]`)?.innerText : discountAmount;
        } else if (bundleObj.tier === 3) {
          quantityTo = productCount < 7 ? 7 - productCount : 2;
          discountAmount = productCount == 7 ? this.querySelector(`.progress-bar__box.discount-box .discount-label[data-tier="4"]`)?.innerText : discountAmount;
        } else if (bundleObj.tier === 4) {
          quantityTo = productCount < 9 ? 9 - productCount : 2;
        } 

        if (parseInt(boxes) <= productCount) {
          const discounts = window.theme.settings.bundleDiscountsPercentage.split(',');
          const lastDiscountI = discounts.length - 1;
          discountAmount = `${discounts[lastDiscountI]}% off`;
        }

        const message = bundleObj.tier === tierNumber && (productCount === parseInt(boxes) || (parseInt(boxes) < productCount))? `Congrats! You get ${discountAmount}` : `add ${quantityTo} more for ${discountAmount}`;
        messageEl.innerHTML = message;
      }
    }

    updateCartProgressBar() {
      let eligibleProducts = JSON.parse(localStorage.getItem('bundleProducts')) ? JSON.parse(localStorage.getItem('bundleProducts')) : {tier: 0, products:[],};
      const contentEl = document.querySelectorAll('.cart-drawer__progress-bar .progress-bar__content');

      contentEl.forEach((content) => {
        const tierNumber = parseInt(window.theme.settings.bundleTotalTier);
        const countEl = parseInt(content.getAttribute('data-count'));
        const tierEl = parseInt(content.getAttribute('data-tier'));
        const productCount = parseInt(eligibleProducts.products.length);

        if (eligibleProducts.tier < tierEl) {
          content.querySelector('.bar-fullfilled')?.setAttribute('data-length', 'false');
        } 
        
        if ((tierNumber === 1 || (tierNumber > 1 && productCount <= 3)) && productCount > 0 && countEl === 3) {
          if (productCount === 1) {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'third');
          } else if (productCount === 2) {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'half');
          } else {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'full');
          }
        } else if ((tierNumber === 2 || (tierNumber > 2 && productCount <= 5)) && productCount > 3  && countEl === 5) {
          document.querySelector('.progress-bar__content[data-count="3"] .bar-fullfilled').setAttribute('data-length', 'full');
          if (productCount === 4) {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'half');
          } else {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'full');
          }
        } else if ((tierNumber === 3 || (tierNumber > 3 && productCount <= 7)) && productCount > 5  && countEl === 7) {
          document.querySelector('.progress-bar__content[data-count="3"] .bar-fullfilled').setAttribute('data-length', 'full');
          document.querySelector('.progress-bar__content[data-count="5"] .bar-fullfilled').setAttribute('data-length', 'full');
          if (productCount === 6) {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'half');
          } else {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'full');
          }
        } else if ((productCount >= 9 || productCount > 7) && countEl === 9) {
          document.querySelector('.progress-bar__content[data-count="3"] .bar-fullfilled').setAttribute('data-length', 'full');
          document.querySelector('.progress-bar__content[data-count="5"] .bar-fullfilled').setAttribute('data-length', 'full');
          document.querySelector('.progress-bar__content[data-count="7"] .bar-fullfilled').setAttribute('data-length', 'full');
          if (productCount === 8) {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'half');
          } else {
            content.querySelector('.bar-fullfilled').setAttribute('data-length', 'full');
          }
        }
      });
    }
  }

  customElements.define('bundle-collection', BundleCollection);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
